import React from 'react';
import { motion } from 'framer-motion';
import { SiUnity, SiDotnet, SiApple } from 'react-icons/si';
import { HiAcademicCap, HiLightningBolt, HiCode } from 'react-icons/hi';
import { useLanguage } from '../i18n/LanguageContext';
import './About.css';

const highlightIcons = [
  { key: 'unity', icon: <SiUnity /> },
  { key: 'csharp', icon: <SiDotnet /> },
  { key: 'apple', icon: <SiApple /> },
  { key: 'degree', icon: <HiAcademicCap /> },
  { key: 'tutor', icon: <HiLightningBolt /> },
  { key: 'fullstack', icon: <HiCode /> },
];

const About = () => {
  const { t } = useLanguage();

  return (
    <section className="about section" id="about">
      <div className="container">
        <motion.div
          className="about__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">{t('about.label')}</span>
          <h2 className="section-title">
            {t('about.titleStart')}<span className="gradient-text">{t('about.titleHighlight')}</span>
          </h2>
        </motion.div>

        <div className="about__content">
          <motion.div
            className="about__text"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p>
              {t('about.p1Start')}<strong>{t('about.p1Bold')}</strong>{t('about.p1End')}
            </p>
            <p>
              {t('about.p2Start')}<strong>{t('about.p2Bold')}</strong>{t('about.p2End')}
            </p>
            <p>{t('about.p3')}</p>
          </motion.div>

          <motion.div
            className="about__highlights"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            {highlightIcons.map((item, i) => {
              const data = t(`about.highlights.${item.key}`);
              return (
                <motion.div
                  className="about__highlight-card"
                  key={item.key}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 * i + 0.4 }}
                  whileHover={{ y: -4, borderColor: 'rgba(0, 212, 170, 0.3)' }}
                >
                  <div className="about__highlight-icon">{item.icon}</div>
                  <div>
                    <h4 className="about__highlight-label">{data.label}</h4>
                    <p className="about__highlight-desc">{data.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
